export default "__VITE_ASSET__CL1LV15u__"